export interface Edition {
  name: string
  price: number
}

export interface Book {
  id: string
  title: string
  subtitle: string
  author: string
  year: string
  genre: string
  cover: string
  description: string
  isbn: string
  pages: number
  format: string
  currency: 'USD'
  editions: Edition[]
  purchaseUrl?: string
  purchaseLabel?: string
}

export const CURRENCY_NOTE =
  'All prices are listed and charged in U.S. Dollars (USD). Applicable sales tax and shipping are calculated at checkout.'

export function formatPrice(amount: number, currency: 'USD' = 'USD'): string {
  return `${new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount)} ${currency}`
}

export function lowestPrice(book: Book): number {
  return Math.min(...book.editions.map((e) => e.price))
}

export const books: Book[] = [
  {
    id: 'kalon',
    title: 'Kalón',
    subtitle: 'A Journey Through Ancient Beauty',
    author: 'Ammonious',
    year: '2026',
    genre: 'Historical Fiction',
    cover:
      'https://cdn.magicpatterns.com/uploads/ockt8Bu7KApUGMMbLKsumk/KalonCover_kick.png',
    description:
      'Set against the gilded splendor of ancient Egypt, Kalón follows a search for meaning through the sacred art, ritual, and philosophy of a civilization obsessed with the eternal. A sweeping, richly imagined narrative from the pen of Ammonious.',
    isbn: '979-8-9947174-0-0',
    pages: 219,
    format: 'Paperback & Ebook',
    currency: 'USD',
    editions: [
      { name: 'Paperback', price: 24.99 },
      { name: 'Ebook', price: 9.99 },
    ],
    purchaseUrl:
      'https://www.kickstarter.com/projects/kalonbook2026/kalon-book-launch',
    purchaseLabel: 'Order on Kickstarter',
  },
  {
    id: 'man-know-thyself',
    title: 'Man, Know Thyself',
    subtitle: 'Revealing the Mysteries of the Ancient Egyptian Concept of the Soul',
    author: 'Deleon Publishing',
    year: '2015',
    genre: 'Ancient Egyptian Spirituality',
    cover:
      'https://cdn.magicpatterns.com/uploads/9a3W5kFJnjRUjkRsQVceSu/MKTCover.jpg',
    description:
      'A non-fiction account of the ancient Egyptian notion of the soul, exploring twelve of its most important elements across ten chapters. From Khaibit, Ba, Ka, Khat, and Sahu to the soul’s shadow existence, living state, and immortality, the book uses ancient terms alongside Holy Scripture to bridge Eastern and Western understandings of the soul and illuminate the Egyptian idea of transcendence.',
    isbn: 'B0158ZJSI6',
    pages: 213,
    format: 'Kindle Edition',
    currency: 'USD',
    editions: [{ name: 'Kindle Edition', price: 9.99 }],
    purchaseUrl:
      'https://www.amazon.com/Man-Know-Thyself-Revealing-Mysteries-ebook/dp/B0158ZJSI6/',
    purchaseLabel: 'Buy on Amazon',
  },
  {
    id: 'psychostasia',
    title: 'Psychostasia',
    subtitle: 'The Ancient Egyptian Scene of the Weighing of the Heart',
    author: 'Deleonpublishing',
    year: '2011',
    genre: 'Ancient Egyptian Spirituality',
    cover:
      'https://cdn.magicpatterns.com/uploads/1G6cCd3wPCGRLeYCaeNjK3/Screenshot_2026-07-22_at_11.40.33_AM.png',
    description:
      'A concise journey into the mindset of ancient Egyptian spiritual culture. Through the evocative scene of the weighing of the heart, the author offers a thought-provoking and insightful perspective on one of antiquity’s most intriguing visions of life after death.',
    isbn: '1456413945',
    pages: 146,
    format: 'Paperback',
    currency: 'USD',
    editions: [{ name: 'Paperback', price: 12.95 }],
    purchaseUrl:
      'https://www.amazon.com/Psychostasia-Ancient-Egyptian-Scene-Weighing/dp/1456413945',
    purchaseLabel: 'Buy on Amazon',
  },
]
